const he = {
  nav: {
    home: "בית",
    about: "אודותינו",
    destinations: "יעדים",
    tours: "סיורים וחבילות",
    gallery: "גלריה",
    testimonials: "המלצות",
    blog: "בלוג",
    contact: "צור קשר",
    experiences: "חוויות",
    vip: "VIP עסקי",
    vipFull: "נסיעות VIP עסקיות",
    worldcup: "גביע העולם 2030",
    menu: "תפריט",
    chatWhatsApp: "צ'אט בוואטסאפ",
    jewishHeritage: "טיולי כשרות"
  },
  hero: {
    welcome: "ברוכים הבאים למרוקו.",
    welcomeHome: "ברוכים הבאים הביתה.",
    subtitle: "סיורים פרטיים יוקרתיים, חוויות אותנטיות,",
    subtitleLine2: "ושירות אישי מלא ברחבי מרוקו —",
    subtitleGold: "מנוהל אישית על ידי המנכ\"ל.",
    whatsappBtn: "שוחח עם אילן (מנכ\"ל) עכשיו בוואטסאפ",
    badgeFast: "תגובה מהירה",
    badgePersonal: "שירות אישי",
    badge247: "זמינות 24/7",
    limitedAvail: "זמינות מוגבלת",
    personalizedOnly: "טיולים מותאמים אישית בלבד"
  },
  strip: {
    privateTours: "סיורים פרטיים",
    localExperts: "מומחים מקומיים",
    bestHotels: "המלונות הטובים",
    luxuryTransport: "תחבורה יוקרתית",
    satisfaction: "100% שביעות רצון"
  },
  cta: {
    whatsapp: "שוחח עם אילן (מנכ\"ל) עכשיו בוואטסאפ",
    whatsappFloating: "צ'אט בוואטסאפ",
    whatsappInquiry: "שלום, אני מעוניין בחוויית נסיעות פרימיום למרוקו."
  },
  home: {
    vipBannerTitle: "חוויות נסיעה VIP במרוקו",
    vipBannerText: "גישה בלעדית, נהגים פרטיים ולינה יוקרתית לנוסעים מבחינים.",
    vipBannerBtn: "גלה שירותי VIP",
    wcBadge: "🇲🇦 גביע העולם מרוקו 2030",
    wcTitle: "מרוקו 2030",
    wcText: "חבילות בלעדיות לגביע העולם המשלבות כדורגל, תרבות מרוקאית, אירוח VIP וחוויות יוקרה.",
    wcBtn: "צפה בחבילות",
    galleryTitle: "גלריה",
    gallerySubtitle: "הצצה למסע המרוקאי העתידי שלך",
    exploreDestination: "חקור יעד",
    featuredToursTitle: "סיורים וחבילות מומלצים",
    featuredToursSubtitle: "חוויות שנאצרו בקפידה להרפתקה המרוקאית המושלמת",
    viewAllTours: "צפה בכל הסיורים",
    culinaryTitle: "האוכל שלנו - הטוב בעולם",
    culinarySubtitle: "חוו מצוינות קולינרית מרוקאית 🍲",
    culinaryBtn: "גלה חוויות אוכל",
    culinaryIntro: "ב-Morocco Loves You, אוכל הוא לא רק אכילה. זהו מסע ללב התרבות המרוקאית. אנו מציעים חוויות קולינריות אותנטיות שנבחרו בקפידה — מארוחות ביתיות מסורתיות ועד לגסטרונומיה מרוקאית עילית, הכל מוכן באהבה ועם המרכיבים המקומיים הטריים ביותר.",
    videoTitle: "המלצות",
    unityQuote: "Morocco Loves You מקבלת בברכה את כל התרבויות, כל האמונות וכל העמים.",
    unityAlt: "באנר האחדות של Morocco Loves You",
    testimonialsTitle: "מה אומרים אורחי ה-VIP שלנו",
    testimonialsSubtitle: "ביקורות אמיתיות מנוסעים בינלאומיים",
    readMoreReviews: "קרא עוד ביקורות",
    viewAllTransport: "צפה בכל שירותי ההסעות",
    transportTitle: "שירותי ההסעות והנהגים ה-VIP שלנו",
    transportSubtitle: "יוקרה, נוחות ובטיחות ברחבי מרוקו 🌍",
    transportIntro: "ב-Morocco Loves You, הסעות הן לא רק מעבר ממקום למקום. הן חלק מהחוויה. אנו מספקים רכבים מודרניים, נקיים, נוחים וממוזגים לחלוטין בכל רחבי מרוקו — עם נהגים מקצועיים, אירוח חם ושירות VIP מהרגע הראשון."
  },
  tours: {
    pageTitle: "סיורים וחבילות",
    pageSubtitle: "בחר מחבילות הנסיעה שלנו שנאצרו בקפידה",
    sectionTitle: "החבילות שלנו",
    sectionIntro: "מהרפתקאות מדבר ועד מפלטי חוף, יש לנו את החבילה המושלמת לכל נוסע",
    howToBook: "איך להזמין",
    step1Title: "בחר סיור",
    step1Text: "עיין בחבילות שלנו ובחר את המתאימה לך",
    step2Title: "לחץ על הזמן",
    step2Text: "לחץ על כפתור \"הזמן עכשיו\" בסיור שבחרת",
    step3Title: "מלא פרטים",
    step3Text: "ספק את תאריכי הנסיעה והמידע האישי שלך",
    step4Title: "אישור",
    step4Text: "קבל אישור ופרטי מסלול בדוא\"ל",
    customTitle: "צריך חבילה מותאמת אישית?",
    customText: "צור קשר ליצירת חוויה מרוקאית מותאמת אישית",
    customBtn: "צור קשר",
    days: "ימים",
    highlights: "נקודות עניין:",
    bookNow: "הזמן עכשיו",
    highlightsLabel: "נקודות עניין:",
    viewFullDetails: "צפה בפרטים המלאים",
    viewDetails: "צפה בפרטים",
    premiumPackage: "חבילת פרימיום",
    arrival: "הגעה:",
    route: "מסלול:",
    flights: "טיסות:",
    transportation: "תחבורה:",
    hotels: "מלונות:",
    foodDining: "אוכל וארוחות:",
    whatsIncluded: "מה כלול:",
    attractionsExperiences: "אטרקציות וחוויות:",
    specialSaharaExperience: "חוויית סהרה מיוחדת:",
    suitableFor: "מתאים עבור:",
    importantNotes: "הערות חשובות:",
    priceInformation: "מידע על מחירים:",
    priceWarningText: "המחירים עשויים להשתנות בהתאם למחירי הטיסות, שערי חליפין, חגים, עונות וזמינות המלונות.",
    safetyComfort: "בטיחות ונוחות:",
    safetyText: "אנו עובדים בתיאום עם הרשויות המרוקאיות ושירותי הביטחון על מנת להבטיח את בטיחותם ונוחותם של אורחינו.",
    safetyTextBrief: "מתואם עם הרשויות המרוקאיות לבטיחותכם.",
    givesMore: "Morocco Loves You נותנת יותר:",
    givesMoreText: "יותר אהבה, אכפתיות, מקצועיות, שמחה ובטיחות. סיורים קלים ומרגיעים עם הכנסת אורחים אנושית אמיתית.",
    givesMoreBrief: "Morocco Loves You:",
    givesMoreTextBrief: "יותר אהבה, אכפתיות ומקצועיות.",
    bookThisPackage: "הזמן חבילה זו",
    backToPackages: "חזרה לחבילות",
    premiumMoroccoPackages: "חבילות פרימיום מרוקו",
    premiumMoroccoPackagesDesc: "חוויות בלעדיות שנאצרו בקפידה עבור האורחים הבולטים שלנו.",
    suitable: {
      couples: "זוגות",
      families: "משפחות",
      groups: "קבוצות",
      solo: "מטיילי סולו",
      seniors: "אזרחים ותיקים",
      companies: "חברות",
      agencies: "סוכנויות נסיעות",
      operators: "מפעילי טיולים"
    },
    pkg1: {
      title: "בריחה יוקרתית לסוף שבוע בפס",
      duration: "3 לילות / 4 ימים (חמישי ← ראשון)",
      price: "€790",
      hl1: "טיסות ישירות הלוך ושוב כלולות (לונדון/אירופה)",
      hl2: "מלונות יוקרה 4–5 כוכבים",
      hl3: "חמאם מרוקאי מסורתי",
      hl4: "סדנאות בישول ואמנות",
      hl5: "הופעות מרוקאיות חיות",
      hl1_brief: "טיסות ישירות הלוך ושוב כלולות",
      subtitle: "חבילה הכל כלול – מא' ועד ת'",
      flight1: "טיסות ישירות הלוך ושוב",
      flight2: "כבודה רשומה של 20 ק\"ג",
      flight3: "תיק יד עד 8 ק\"ג",
      inc1: "איסוף מהשדה והעברה חזרה",
      inc2: "מלונות 4–5 כוכבים (חצי פנסיון)",
      inc3: "מטבח מרוקאי טרי ואותנטי",
      inc4: "חוויית תה ומאפים מסורתיים",
      inc5: "מדריך טיולים מקצועי ונהג פרטי",
      inc6: "תחבורה מודרנית ממוזגת",
      inc7: "הופעות חיות מיוחדות (זמרים ורקדנים)",
      inc7_brief: "הופעות חיות מיוחדות",
      inc8: "סיורים בשווקים מסורתיים (תבלינים, פנסים, שטיחים)",
      inc8_brief: "סיורים בשווקים מסורתיים",
      inc9: "סדנאות בישول ואמנות (נדרש תיאום מראש)",
      inc9_brief: "סדנאות בישول ואמנות",
      inc10: "ביקורים במעיינות טבעיים ותצפיות",
      inc11: "טיולי יום לשפשאוון ואיפראן",
      inc12: "ביקורים אצל משפחות מרוקאיות מקומיות",
      inc13: "חוויות הפתעה במהלך הטיול",
      suit1: "זוגות",
      suit2: "משפחות",
      suit3: "קבוצות",
      suit4: "מטיילי סולו",
      suit5: "אזרחים ותיקים",
      suit6: "חברות",
      suit7: "סוכנויות נסיעות",
      suit8: "מפעיلي טיולים"
    },
    pkg2: {
      title: "טיול גילוי יוקרתי במרוקו",
      duration: "6 לילות / 7 ימים (שני ← ראשון)",
      price: "€1490",
      hl1: "מסלول פס וצפון מרוקו",
      hl2: "ביקורים בשפשאוון וטנג'יר",
      hl3: "טיסות ישירות ונהג פרטי",
      hl4: "מיקומים מעולים ושירות ברמה גבוהה",
      hl5: "אירוח מרוקאי אותנטי",
      subtitle: "מסלול פס וצפון מרוקו (הכל כלול)",
      routeText: "2 לילות בפס, לילה 1 בשפשאוון, לילה 1 בטנג'יר, לילה 1 באיפראן, לילה אחרון בפס",
      flight1: "טיסות ישירות הלוך ושוב מאירופה",
      flight2: "20 ק\"ג כבודה + תיק יד",
      trans1: "איסוף והעברה לשדה התעופה",
      trans2: "נהג פרטי מקצועי ומדריך טיולים",
      trans3: "רכבים חדשים וממוזגים",
      hotel1: "מלונות 4–5 כוכבים",
      hotel2: "מיקומים מעולים",
      hotel3: "שירות ברמה גבוהה",
      food1: "חצי פנסיון",
      food2: "מטבח אותנטי",
      food3: "תה מסורתי ומאפים",
      exp1: "הופעות מרוקאיות חיות",
      exp2: "שווקים מסורתיים (תבלינים, פנסים, שטיחים)",
      exp3: "חמאם מרוקאי מסורתי",
      exp4: "ביקורים בטבע וביערות",
      exp5: "תצפיות יפות וטיולי יום",
      exp6: "סדנאות בישول ואמנות",
      exp7: "ביקורים אצל משפחות מקומיות",
      exp8: "הפתעות מיוחדות במהלך הטיול",
      suit1: "זוגות",
      suit2: "משפחות",
      suit3: "קבוצות",
      suit4: "מטיילי סולו",
      suit5: "אזרחים ותיקים",
      suit6: "חברות",
      suit7: "סוכנויות נסיעות"
    },
    pkg3: {
      title: "חוויית מרוקו הגדולה",
      duration: "10 לילות / 11 ימים (מטיילים מכל העולם)",
      price: "€1990",
      hl1: "שירותי קרקע פרימיום מלאים",
      hl2: "קזבלנקה, מרקש ופס",
      hl3: "אגאדיר והפתעות במדבר סהרה",
      hl4: "ביקור בווארזאזאת ושפשאוון",
      hl5: "מוזיקה חיה והופעות מיוחדות",
      subtitle: "✨ חוויית מרוקו הגדולה (שירותי קרקע בלבד)",
      arrivalText: "קזבלנקה או מרקש",
      routeText: "קזבלנקה, רבאט, 2 לילות בפס, טנג'יר, שפשאוון, איפראן, 2 לילות במרקש, אגאדיר, ווארזאזאת, לילה אחרון במרקש",
      note2: "קבוצות מעל 40: הנחה מיוחדת של 50$ לאדם",
      note3: "טיסות בינלאומיות וביטוח אינם כלולים",
      note4: "טיפים לנהג/מדריך אינם כלולים",
      inc1: "שירותי קרקע פרימיום מלאים",
      inc2: "מלונות 4–5 כוכבים (חצי פנסיון)",
      inc3: "מדריך טיולים מקצועי ונהג פרטי",
      inc4: "אוטובוס או מיניבוס ממוזג",
      inc5: "הופעות חיות ואווירה מוזיקלית" ,
      inc6: "שווקים מסורתיים וביקורי חמאם",
      inc7: "סדנאות בישول ואמנות",
      inc8: "טיולים ליערות, מעיינות ותצפיות",
      inc9: "ביקורים אצל משפחות מקומיות",
      inc10: "הפתעות מיוחדות במהלך המסע"
    },
    pkg4: {
      title: "חוויית מרוקו האימפריאלית והסהרה",
      duration: "13 לילות / 14 ימים",
      price: "הכל כלול",
      hl1: "2 לילות במדבר סהרה במרזוגה",
      hl2: "אוהלי פרימיום ממוזגים וסיורי ג'יפים",
      hl3: "ביקור בהרי האטלס ובעמק אוריקה",
      hl4: "מפלי אוזוד והערים האימפריאליות",
      hl5: "שירותי קרקע מלאים מא' ועד ת'",
      subtitle: "✨ חוויית מרוקו האימפריאלית והסהרה (שירותי קרקע מלאים)",
      routeText: "2 לילות במרקש, עמק אוריקה, אגאדיר, 2 לילות במרזוגה, ווארזאזאת, מפלי אוזוד, איפראן, טנג'יר, שפשאוון, 2 לילות בפס, אל-ג'דידה, קזבלנקה",
      sahara1: "אוהלי מדבר יוקרתיים וממוזגים",
      sahara2: "אווירת מוזיקה סביב המדורה",
      sahara3: "סיורי ג'יפים ורכיבה על גמלים",
      sahara4: "שקיעות וזריחות בלתי נשכחות",
      inc1: "שירותי קרקע פרימיום מלאים",
      inc2: "מלונות 4–5 כוכבים (חצי פנסיון)",
      inc3: "מדריך טיולים מקצועי ונהג פרטי",
      inc4: "הופעות חיות מיוחדות ורקדנים",
      inc5: "שווקי תבלינים, שטיחים ופנסים מסורתיים",
      inc6: "חמאם מרוקאי מסורתי",
      inc7: "סדנאות בישول ואמנות"
    }
  },
  destinations: {
    pageTitle: "חקור את יעדי מרוקו",
    pageSubtitle: "גלה מקומות מדהימים לביקור ברחבי מרוקו",
    sectionTitle: "כל היעדים",
    sectionIntro: "מרוקו היא ארץ של נופים מגוונים ומורשת תרבותית עשירה:",
    exploreNow: "חקור עכשיו",
    ctaTitle: "מוכן לתכנן את הטיול?",
    ctaText: "עיין בסיורים והחבילות שלנו למציאת החוויה המרוקאית המושלמת",
    ctaBtn: "צפה בסיורים וחבילות"
  },
  experiences: {
    pageTitle: "מצוינות קולינרית מרוקאית",
    pageSubtitle: "גלה את האוכל שלנו — הטוב בעולם",
    bookViaWhatsApp: "הזמן דרך וואטסאפ"
  },
  vip: {
    pageTitle: "נסיעות VIP ועסקים",
    pageSubtitle: "שירותים בלעדיים למנכ\"לים, משקיעים ונוסעים מבחינים",
    introTitle: "מצוינות חלקה במרוקו",
    introText: "MoroccoLovesYou מספקת רמת שירות ללא תחרות לנוסעים עסקיים, משלחות ואורחי VIP.",
    ctaTitle: "גישה ישירה למנכ\"ל",
    ctaText: "לבקשות דחופות, דבר ישירות עם המייסד והמנכ\"ל, אילן האצ'ואל.",
    ctaBtn: "צור קשר עם אילן עכשיו",
    luxuryTransport: "תחבורה יוקרתית",
    luxuryTransportDesc: "העברות VIP משדה התעופה ונהגים פרטיים דו-לשוניים 24/7.",
    premiumAccom: "לינה פרימיום",
    premiumAccomDesc: "הזמנות בלעדיות במלונות 5 כוכבים, ריאדים יוקרתיים או וילות פרטיות.",
    businessConcierge: "קונסיירז' עסקי",
    businessConciergeDesc: "סיוע מלא לפגישות, הזמנות ארוחות פרטיות ומסלולים מיוחדים.",
    securityPrivacy: "אבטחה ופרטיות",
    securityPrivacyDesc: "שירות דיסקרטי, סביבות מאובטחות וסודיות מוחלטת.",
    support247: "תמיכה 24/7",
    support247Desc: "קשר ישיר עם המנכ\"ל וצוות ייעודי מוכן לסייע בכל עת.",
    customItineraries: "מסלולים מותאמים אישית",
    customItinerariesDesc: "תוכניות נסיעה מותאמות המאזנות בין מחויבויות עסקיות לחוויות תרבותיות."
  },
  worldcup: {
    pageTitle: "גביע העולם מרוקו 2030",
    pageSubtitle: "חבילות VIP בלעדיות לאירוע הספורט הגדול ביותר",
    limitedBadge: "זמינות מוגבלת",
    introTitle: "מסע הכדורגל האולטימטיבי",
    introText: "ב-2030, מרוקו תארח את גביע העולם FIFA. MoroccoLovesYou גאה להציע חבילות יוקרה בלעדיות.",
    packagesTitle: "חבילות גביע העולם פרימיום",
    silverTitle: "חבילת כסף",
    silverSub: "החוויה הבסיסית",
    goldTitle: "חבילת זהב",
    goldSub: "חוויית היוקרה",
    mostPopular: "הפופולרי ביותר",
    diamondTitle: "יהלום VIP",
    diamondSub: "החוויה האולטימטיבית",
    inquireWhatsApp: "ברר דרך וואטסאפ",
    ctaTitle: "הבטח את מקומך לפני עליית המחירים",
    ctaText: "בשל הביקוש הבינלאומי הגבוה, מומלץ להבטיח את חבילת ה-VIP שלך מוקדם.",
    ctaBtn: "צור קשר היום",
    silverF1: "ריאד פרימיום / מלון 4 כוכבים",
    silverF2: "לוגיסטיקה מתוכננת ליום המשחק",
    silverF3: "סיורים מודרכים בערים המארחות",
    silverF4: "קו תמיכה ייעודי 24/7",
    goldF1: "מלון 5 כוכבים / וילת יוקרה",
    goldF2: "העברות פרטיות לשדה התעופה ולמשחקים",
    goldF3: "מחנה מדבר VIP (יומיים)",
    goldF4: "קונסיירז' אישי דו-לשוני",
    diamondF1: "סוויטות נשיאותיות / ארמונות פרטיים",
    diamondF2: "נהג פרטי ואבטחה 24/7",
    diamondF3: "גישה בלעדית לאירועי VIP ומסיבות",
    diamondF4: "טיפול ישיר של המנכ\"ל וקונסיירז' VVIP"
  },
  gallery: {
    pageTitle: "הגלריה שלנו",
    pageSubtitle: "זיכרונות חזותיים ממסעות מרוקאיים בלתי נשכחים",
    picturesTitle: "מרוקו בתמונות",
    picturesIntro: "חקור את אוסף התמונות המרהיבות שלנו ממרוקו",
    videosTitle: "מרוקו בתנועה",
    videosIntro: "חווה את מרוקו דרך אוסף הווידאו שלנו"
  },
  testimonials: {
    pageTitle: "המלצות אורחים",
    pageSubtitle: "קרא מה הנוסעים שלנו אומרים על החוויה המרוקאית",
    sectionTitle: "הנוסעים המרוצים שלנו",
    sectionIntro: "אלפי אורחים מרוצים חוו את הקסם של מרוקו איתנו",
    verifiedGuest: "אורח מאומת",
    ratingsTitle: "הדירוגים שלנו",
    avgRating: "דירוג ממוצע",
    verifiedReviews: "ביקורות מאומתות",
    fromReal: "מנוסעים אמיתיים",
    custSatisfaction: "שביעות רצון לקוחות",
    wouldRecommend: "היו ממליצים",
    shareTitle: "שתף את החוויה שלך",
    shareText: "נהנית מטיול מדהים? נשמח לשמוע!",
    shareBtn: "ספר לנו את הסיפור שלך"
  },
  blog: {
    pageTitle: "בלוג נסיעות",
    pageSubtitle: "סיפורים, טיפים ומדריכים להרפתקה המרוקאית שלך",
    sectionTitle: "מאמרי נסיעות אחרונים",
    sectionIntro: "קרא את המאמרים האחרונים שלנו על נסיעות במרוקו",
    readMore: "קרא עוד ←",
    by: "מאת",
    newsletterTitle: "הרשם לניוזלטר שלנו",
    newsletterText: "קבל את טיפי הנסיעות והמבצעים הבלעדיים האחרונים",
    newsletterPlaceholder: "הזן את האימייל שלך",
    subscribe: "הרשם"
  },
  contact: {
    pageTitle: "צור קשר",
    pageSubtitle: "צור קשר עם הצוות שלנו לתכנון הרפתקת VIP במרוקו",
    getInTouch: "צור קשר",
    getInTouchText: "אנחנו כאן לעזור ולענות על כל שאלה. הצוות שלנו מוכן לסייע לך.",
    address: "כתובת",
    phone: "טלפון",
    email: "אימייל",
    businessHours: "שעות פעילות",
    followUs: "עקבו אחרינו",
    formTitle: "שלח לנו הודעה",
    successMessage: "✓ תודה! נחזור אליך בהקדם.",
    fullName: "שם מלא",
    emailAddress: "כתובת אימייל",
    phoneNumber: "מספר טלפון",
    subject: "נושא",
    selectSubject: "בחר נושא",
    tourInquiry: "בירור סיור",
    bookingQuestion: "שאלת הזמנה",
    customPackage: "חבילה מותאמת",
    feedback: "משוב",
    other: "אחר",
    message: "הודעה",
    sendMessage: "שלח הודעה",
    mapTitle: "מצא אותנו במפה",
    faqTitle: "שאלות נפוצות",
    faq1Q: "מהו הזמן הטוב ביותר לבקר במרוקו?",
    faq1A: "אביב (אפריל-מאי) וסתיו (ספטמבר-אוקטובר) מציעים את מזג האוויר הטוב ביותר.",
    faq2Q: "האם אני צריך ויזה לבקר במרוקו?",
    faq2A: "דרישות הויזה תלויות באזרחותך. מדינות רבות נהנות מכניסה ללא ויזה עד 90 יום.",
    faq3Q: "באיזה מטבע משתמשים במרוקו?",
    faq3A: "הדירהם המרוקאי (MAD) הוא המטבע הרשמי. כספומטים זמינים ברחבי הערים.",
    faq4Q: "באיזו שפה מדברים במרוקו?",
    faq4A: "ערבית וברברית (אמאזיע) הן השפות הרשמיות. צרפתית נפוצה מאוד.",
    faq5Q: "האם מרוקו בטוחה לתיירים?",
    faq5A: "כן, מרוקו בטוחה בדרך כלל לתיירים. המדריכים שלנו מבטיחים חוויה בטוחה.",
    faq6Q: "האם אפשר להתאים אישית את החבילה שלי?",
    faq6A: "בהחלט! אנו מציעים חבילות מותאמות לתחומי העניין, התקציב והתאריכים שלך."
  },
  about: {
    pageTitle: "אודות MoroccoLovesYou",
    pageSubtitle: "השותף האמין שלך לגילוי הקסם של מרוקו",
    storyTitle: "הסיפור שלנו",
    storyP1: "MoroccoLovesYou נוסדה עם משימה פשוטה: לעזור לנוסעים לחוות את היופי האותנטי, התרבות והכנסת אורחים של מרוקו.",
    storyP2: "המייסדת שלנו התאהבה במרוקו ורצתה לחלוק את התשוקה הזו עם העולם.",
    missionTitle: "🎯 המשימה שלנו",
    missionText: "לספק חוויות נסיעה יוצאות דופן שמציגות את המורשת התרבותית העשירה של מרוקו.",
    visionTitle: "🌟 החזון שלנו",
    visionText: "להיות חברת התיירות המובילה במרוקו הידועה באותנטיות ואמינות.",
    whyTitle: "למה לבחור ב-MoroccoLovesYou?",
    expertTitle: "ידע מומחה",
    expertText: "לצוות שלנו ידע נרחב על מרוקו.",
    localTitle: "קשרים מקומיים",
    localText: "אנחנו עובדים עם מדריכים ומשפחות מקומיות אותנטיות.",
    valueTitle: "ערך מיטבי",
    valueText: "מחירים תחרותיים ללא פשרות על איכות.",
    safetyTitle: "בטיחות ותמיכה",
    safetyText: "תמיכת לקוחות 24/7 וביטוח נסיעות מקיף.",
    sustainTitle: "תיירות בת-קיימא",
    sustainText: "אנחנו תומכים בקהילות מקומיות ומתרגלים תיירות אחראית.",
    bookingTitle: "הזמנה קלה",
    bookingText: "תהליך הזמנה פשוט עם אפשרויות תשלום גמישות.",
    teamTitle: "הצוות שלנו",
    teamSubtitle: "הכירו את האנשים הנלהבים מאחורי MoroccoLovesYou",
    happyTravelers: "נוסעים מרוצים",
    yearsExp: "שנות ניסיון",
    destinationsCount: "יעדים",
    satisfactionRate: "שיעור שביעות רצון"
  },
  footer: {
    description: "גלה את הקסם של מרוקו איתנו. חווה הרפתקאות בלתי נשכחות וצור זיכרונות לכל החיים.",
    quickLinks: "קישורים מהירים",
    more: "עוד",
    contactInfo: "פרטי קשר",
    copyright: "© 2024 MoroccoLovesYou. כל הזכויות שמורות."
  },
  starBanner: {
    ceoMessage: "הודעת המנכ\"ל",
    watchVideo: "צפה בווידאו שלי",
    readMessage: "וקרא את ההודעה שלי",
    getToKnow: "הכר את",
    ilanPersonally: "אילן באופן אישי"
  },
  tourMini: {
    days: "10 ימים",
    nights: "/ 9 לילות",
    title: "סיור פרימיום\nמרוקו",
    years: "2026 - 2027",
    departures: "יציאות חודשיות",
    allIncluded: "הכל כלול\nפנסיון מלא",
    recommendations: "המלצות",
    recCount: "500+ מטיילים מאושרים"
  },
  cityDetail: {
    notFound: "העיר לא נמצאה",
    backHome: "חזרה לדף הבית",
    discoverSubtitle: "גלה את היופי והתרבות",
    planTrip: "תכנן את הטיול שלי ל",
    galleryOf: "גלריה של",
    bookExperience: "הזמן חוויה זו",
    requestItinerary: "בקש מסלול מלא",
    readyToVisit: "מוכן לבקר ב",
    readyToVisitText: "תן לנו לתכנן את המסע המושלם שלך ליעד המדהים הזה",
    planMyTrip: "תכנן את הטיול שלי",
    talkExpert: "דבר עם מומחה"
  },
  transportation: {
    pageTitle: "הסעות VIP ונהגים",
    pageSubtitle: "יוקרה, נוחות ובטיחות ברחבי מרוקו",
    introTitle: "שירותי ההסעות והנהגים ה-VIP שלנו",
    introP1: "ב-Morocco Loves You, הסעות הן לא רק מעבר ממקום למקום.",
    introP2: "הן חלק מהחוויה.",
    introP3: "אנו מספקים רכבים מודרניים, נקיים, נוחים וממוזגים לחלוטין בכל רחבי מרוקו — עם נהגים מקצועיים, אירוח חם ושירות VIP מהרגע הראשון.",
    introP4: "בין אם אתם מטיילים כזוג, משפחה, משלחת עסקית או קבוצה פרטית, אנו דואגים שהמסע שלכם יהיה בטוח, מרגיע ובלתי נשכח.",
    servicesTitle: "שירותי התחבורה שלנו כוללים",
    servicesList: [
      "אוטובוסי VIP מודרניים",
      "מיניבוסים יוקרתיים",
      "מכוניות פרטיות",
      "ג'יפים 4x4 להרפתקאות מדבר",
      "לימוזינות VIP",
      "איסוף והחזרה משדה התעופה",
      "נהגים מקצועיים דוברי מספר שפות",
      "מיזוג אוויר נוח",
      "רכבים נקיים ומאורגנים",
      "מקררים ברכבים נבחרים",
      "מערכות טלוויוזיה ובידור",
      "מוזיקה במהלך הנסיעה",
      "נהיגה בטוחה וחלקה",
      "סיוע 24/7 ברחבי מרוקו"
    ],
    driversTitle: "הכירו את הנהגים שלנו",
    driversText1: "הנהגים שלנו הם חלק ממשפחת Morocco Loves You.",
    driversText2: "מקצועיים, מכבדים, מנוסים ותמיד מוכנים לעזור עם חיוך.",
    driversText3: "רבים מהנהגים שלנו דוברים מספר שפות ומכירים את מרוקו לעומק — מה שעוזר לאורחים שלנו להרגיש בנוח, בטוחים ומחוברים לאורך כל המסע.",
    safetyTitle: "בטיחות ונוחות מעל הכל",
    safetyText1: "הנוחות והבטיחות שלכם הם בראש סדר העדיפויות שלנו.",
    safetyText2: "כל הרכבים עוברים תחזוקה שוטפת, מנוקים ומוכנים בקפידה לפני כל נסיעה.",
    safetyText3: "אנו עובדים רק עם נהגים מקצועיים אמינים ושותפי תחבורה באיכות גבוהה.",
    categories: {
      buses: "אוטובוסי VIP",
      minibuses: "מיניבוסים יוקרתיים",
      cars: "מכוניות פרטיות והעברות VIP",
      jeeps: "ג'יפים 4x4 ותחבורה מדברית",
      meetDrivers: "הכירו את הנהגים שלנו",
      videos: "סרטוני חווית נסיעה"
    },
    videoGalleryTitle: "סרטוני חווית VIP",
    ctaTitle: "מוכנים לחקור את מרוקו בנוחות?",
    moroccoLine: "קו ישיר למרוקו: +212 6 63 63 05 79"
  },
  jewishHeritage: {
    pageTitle: "טיולי כשרות יוקרתיים במרוקו",
    pageSubtitle: "מורשת יהודית אותנטית, מטבח 100% כשר, אירוח יוקרתי וחוויות מרוקאיות ייחודיות.",
    introTitle: "חוויית מורשת יהודית יוקרתית",
    introHeading: "גלו את מרוקו היהודית האותנטית",
    introText: "גלו את השורשים העמוקים של ההיסטוריה היהודית במרוקו עם חוויית נסיעה אלגנטית, אותנטית ויוקרתית. אנו מתמחים בהפקת מסעות מושלמים לקהילות יהודיות ברחבי העולם, תוך התמקדות במורשת, חיבור ונוחות מוחלטת.",
    introQuote: "\"מרוקו היא ארץ של סובלנות ודו-קיום, שבה המורשת היהודית נשמרת באהבה ובכבוד.\"",
    experiencesTitle: "החוויות הכשרות שלנו כוללות",
    experiencesList: [
      "מזון ומסעדות 100% כשר",
      "שף כשר פרטי זמין",
      "מטבח יהודי מרוקאי מסורתי",
      "מלונות יוקרה 4 ו-5 כוכבים",
      "תחבורה פרטית VIP",
      "מדריכים מקצועיים דוברי שפות",
      "סיורי מורשת יהודית ובתי כנסת",
      "בתי עלמין ומוזיאונים יהודיים",
      "חוויות מדבר סהרה וחמאם",
      "סיוע מקצועי 24/7"
    ],
    expFood: "אוכל 100% כשר",
    expRestaurant: "מסעדה כשרה",
    expChef: "שף כשר פרטי זמין",
    expCuisine: "מטבח יהודי מרוקאי מסורתי",
    expHotels: "מלונות יוקרה 4 ו-5 כוכבים",
    expDeluxeHotels: "מלונות דלוקס זמינים לפי בקשה",
    expTransport: "תחבורה פרטית VIP",
    expDrivers: "נהגים מקצועיים",
    expAC: "רכבים ממוזגים",
    expWifi: "אינטרנט אלחוטי, טלוויזיה ומקררים ברכבים נבחרים",
    expGuides: "מדריכים מקצועיים דוברי שפות",
    expStaff: "צוות דובר עברית / אנגלית / צרפתית / ספרדית / רוסית / גרמנית",
    expHeritage: "סיורי מורשת יהודית",
    expSynagogues: "בתי כנסת עתיקים",
    expCemeteries: "בתי עלמין יהודיים",
    expMuseums: "מוזיאונים יהודיים",
    expSpiritual: "חוויות רוחניות ותרבותיות",
    expDesert: "חוויות במדבר סהרה",
    expHammam: "חוויות חמאם מרוקאי",
    expAttractions: "אטרקציות ייחודיות ברחבי מרוקו",
    expAssistance: "תמיכה וסיוע 24/7",
    packagesTitle: "חבילות נסיעה כשרות גמישות",
    packagesIntro: "אנו מתאימים אישית כל טיול בהתאם לצרכים, למסורות, לסגנון הנסיעה, לתאריכים ולציפיות של האורחים שלנו.",
    packageOptions: ["4-5 ימים", "7-8 ימים", "10-11 ימים", "13-14 ימים", "21 ימים", "סיורים פרטיים בהתאמה אישית"],
    package4_5: "4-5 ימים",
    package7_8: "7-8 ימים",
    package10_11: "10-11 ימים",
    package13_14: "13-14 ימים",
    package21: "21 ימים",
    packageTailor: "סיורים פרטיים בהתאמה אישית",
    packagesQuote: "“אנו מתאימים אישית כל טיול בהתאם לצרכים, למסורות, לסגנון הנסיעה, לתאריכים ולציפיות של האורחים שלנו.”",
    safetyTitle: "נסיעה נוחה, מקצועית ובטוחה",
    safetyText: "הסיורים שלנו מתנהלים תוך מתן תשומת לב מרבית לנוחות, ארגון, איכות השירות ותיאום מקצועי ברחבי מרוקו.",
    safetyQuote: "“הסיורים שלנו מתנהלים תוך מתן תשומת לב מרבית לנוחות, ארגון, איכות השירות ותיאום מקצועי ברחבי מרוקו.”",
    b2bTitle: "שותפויות נסיעות יהודיות B2B",
    b2bText: "אנו משתפים פעולה עם קהילות יהודיות, בתי כנסת, רבנים ומפעילי טיולים כשרים ברחבי העולם כדי ליצור מסעות מורשת בעלי משמעות.",
    b2bPartnersList: "אנו עובדים עם: קהילות יהודיות, בתי כנסת, רבנים, ארגונים יהודיים, מפעילי טיולים כשרים וסוכנויות נסיעות ברחבי העולם.",
    partnerBtn: "שתף פעולה איתנו",
    galleryTitle: "גלריית חוויות כשרות",
    videosTitle: "סרטונים נבחרים",
    ctaTitle: "מוכנים להתחיל את המסע שלכם?",
    msgAllan: "שלח הודעה לאילן בוואטסאפ",
    callMorocco: "התקשר למרוקו: +212 6 63 63 05 79",
    ceoContact: "שוחח עם אילן האצ'ואל ישירות בוואטסאפ",
    exploreBtn: "חקור סיורים כשרים"
  },
  aria: {
    openMenu: "פתח תפריט",
    closeMenu: "סגור תפריט",
    whatsappSocial: "WhatsApp",
    kosherTravel: "טיולי כשרות במרוקו",
    logoAlt: "לוגו MoroccoLovesYou",
    kingAlt: "מלך מרוקו",
    kosherOptionsAlt: "אפשרויות כשרות",
    jewishHeritageArchitecture: "אדריכלות מורשת יהודית",
    kosherMoroccanTable: "שולחן מרוקאי כשר",
    luxuryHospitality: "אירוח יוקרתי",
    kosherExperience: "חוויה כשרה",
    jewishHeritageMorocco: "מורשת יהודית במרוקו",
    kosherFoodMorocco: "אוכל כשר במרוקו",
    jewishHeritageExperience: "חוויית מורשת יהודית"
  }
};

export default he;
